<template>
  <div>
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Source Onboarding'"
      :valueData="data.source_onboarding_name"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor Rekening'"
      :valueData="data.account_number"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Perusahaan'"
      :valueData="text(data.company_name)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Merchant'"
      :valueData="data.merchant_name"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Pemilik Usaha'"
      :valueData="data.owner_name"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nomor KTP Pemilik Usaha'"
      :valueData="text(data.ktp_no)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="
        accountType == 'Corporate'
          ? 'Nomor NPWP Perusahaan'
          : 'Nomor NPWP Pemilik Usaha'
      "
      :valueData="text(data.npwp_no)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Email'"
      :valueData="data.email"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'No Handphone Pemilik Usaha'"
      :valueData="data.mobile_phone"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="
        accountType == 'Corporate' ? 'No Telepon Perusahaan' : 'No Telepon'
      "
      :valueData="merchantPhone == ' ' ? '( not set )' : merchantPhone"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Channel QR'"
      :valueData="data.channel_qr"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Model Usaha'"
      :valueData="data.merchant_model"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Jenis Usaha'"
      :valueData="data.mcc_description"
    />
    <!-- Dokumen MDR Khusus -->
    <pdf-detail-api
      v-if="data?.custom_mdr_id"
      :documentId="data.custom_mdr_id"
      :filename="data.custom_mdr_filename"
      type="new"
      label="Dokumen MDR Khusus"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'MDR On-Us'"
      :valueData="data.mdr_on_us"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'MDR Off-Us'"
      :valueData="data.mdr_off_us"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kriteria Merchant'"
      :valueData="data.merchant_criteria"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Alamat Merchant'"
      :valueData="data.address"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kota, Kecamatan, Kode Pos'"
      :valueData="
        data.kabupaten_kota + ', ' + data.kecamatan + ', ' + data.kode_pos
      "
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'KODE BC/KO'"
      :valueData="text(data.bcko)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Merchant Category Segment'"
      :valueData="text(data.cmer)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Referral Code'"
      :valueData="text(data.referral_code)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Type Settlement'"
      :valueData="data.settlement_type_name"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'ID Approver 1'"
      :valueData="data.approver_1"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'ID Approver 2'"
      :valueData="data.approver_2"
    />

    <div v-if="data != null && data.id_qr_type == '2'">
      <v-card
        class="mb-12"
        height="20px"
        :style="{
          'box-shadow': '0 0 black',
          'margin-top': '20px',
        }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Endpoint</h3>
        </div>
      </v-card>
      <data-detail-row
        :oldValueData="false"
        :data="data"
        :label="'URL'"
        :valueData="text(data.endpoint)"
      />
      <data-detail-row
        :oldValueData="false"
        :data="data"
        :label="'IP Address'"
        :valueData="text(data.ip_address)"
      />
      <!-- SNAP Fields -->
      <data-detail-row
        v-if="isApiSnap"
        :oldValueData="false"
        :data="data"
        :label="'Callback Partner URL Token'"
        :valueData="text(data.access_token_endpoint)"
      />
      <data-detail-row
        v-if="isApiSnap"
        :oldValueData="false"
        :data="data"
        :label="'Callback Partner ID'"
        :valueData="text(data.cred_client_id)"
      />
      <data-detail-row
        v-if="isApiSnap"
        :oldValueData="false"
        :data="data"
        :label="'Callback Partner Client Secret'"
        :valueData="text(data.client_secret)"
      />
      <v-row v-if="isApiSnap">
        <v-col cols="10" sm="4">Public Key Partner</v-col>
        <v-col cols="2" sm="1">:</v-col>
        <v-col cols="12" sm="7">
          <div class="public-key-container">
            <v-textarea
              :value="decryptedPublicKey"
              outlined
              disabled
              dense
              readonly
              rows="3"
              class="fixed-height-textarea"
              hide-details
            />
            <v-btn
              icon
              small
              class="copy-btn"
              @click="copyPublicKey"
              title="Copy Public Key"
            >
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Additional Data</h3>
      </div>
    </v-card>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tempat Lahir Pemilik Usaha'"
      :valueData="text(data.owner_city_of_birth)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tanggal Lahir Pemilik Usaha'"
      :valueData="text(data.owner_date_of_birth)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Alamat Pemilik Usaha'"
      :valueData="text(data.owner_address)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kode Pos Pemilik Usaha'"
      :valueData="text(data.owner_postal_code)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Nama Pemilik Rekening'"
      :valueData="text(data.account_holder_name)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Kantor Cabang Terdekat'"
      :valueData="text(data.bni_branch_office)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Tahun Berdiri'"
      :valueData="text(data.merchant_est_since)"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Email Merchant'"
      :valueData="text(data.merchant_email)"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Dokumen</h3>
      </div>
    </v-card>
    <div v-if="data.image_ktp">
      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Selfi KTP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_selfie_ktp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto TTD </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_tanda_tangan" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto Lokasi Usaha </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_lokasi" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NPWP </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <v-img :src="data.image_npwp" />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="10" sm="4"> Foto NIB </v-col>
        <v-col cols="2" sm="1"> : </v-col>
        <v-col cols="12" sm="7">
          <v-card elevation="2">
            <app-pdf-viewer
              :id="$route.params.id"
              :pdfData="data.image_nib"
              pdfType="pdfNibView"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>

    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'NMID'"
      :valueData="
        data.nmid == '' || data.nmid == null ? '( not set )' : data.nmid
      "
    />
    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Keterangan</h3>
      </div>
    </v-card>
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Status'"
      :valueData="data.status"
    />
    <data-detail-row
      :oldValueData="false"
      :data="data"
      :label="'Last Update'"
      :valueData="data.updated_at"
    />

    <v-card
      v-if="isCloseMerchant"
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Close Merchant</h3>
      </div>
    </v-card>

    <data-detail-row
      v-if="isCloseMerchant"
      :oldValueData="false"
      :data="data"
      :label="'Kategori Penutupan'"
      :valueData="closedMerchantCategoryLabel"
    />

    <data-detail-row
      v-if="isCloseMerchant"
      :oldValueData="false"
      :data="data"
      :label="'Alasan'"
      :valueData="text(data.reason)"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      v-if="data != null && data.remark != null"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Remarks</h3>
      </div>
    </v-card>
    <v-card
      v-if="data != null && data.remark != null"
      :style="{ 'box-shadow': '0 0 black' }"
    >
      <remark-row :data="data" />
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-btn
          small
          color="orange"
          dark
          :style="{ margin: '2px' }"
          @click="back"
        >
          <v-icon dark left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { text } from '../../lib/helpers';
import decryptAES256GCM from '../../lib/utils/decryptAES';

export default {
  components: {
    DataDetailRow: () => import('./DataDetailRow.vue'),
    RemarkRow: () => import('./RemarkRow.vue'),
    AppPdfViewer: () => import('../form/AppPdfViewer.vue'),
    PdfDetailApi: () => import('../form/PdfDetailApi.vue'),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCloseMerchant() {
      return (
        this.data != null &&
        this.data.closed_merchant_category != null &&
        this.data.closed_merchant_category !== ''
      );
    },

    closedMerchantCategoryLabel() {
      const category = this.data?.closed_merchant_category;
      if (category == null || category === '') return text(category);
      const code = this.data?.closed_merchant_code;
      return code ? `${code} - ${category}` : category;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    isApiSnap() {
      if (!this.data) return false;
      // eslint-disable-next-line eqeqeq
      return this.data.id_qr_type == 2 && this.data.client_version === 'SNAP';
    },
    decryptedPublicKey() {
      if (!this.isApiSnap || !this.data.public_key_inbound) return '';
      try {
        return decryptAES256GCM(this.data.public_key_inbound);
      } catch (e) {
        // If decryption fails, return original value
        return this.data.public_key_inbound;
      }
    },
  },
  methods: {
    text,

    back() {
      this.$router.back();
    },

    async copyPublicKey() {
      try {
        await navigator.clipboard.writeText(this.decryptedPublicKey);
        this.$toast.success('Public Key copied to clipboard');
      } catch (err) {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = this.decryptedPublicKey;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$toast.success('Public Key copied to clipboard');
      }
    },
  },
};
</script>

<style scoped>
.fixed-height-textarea ::v-deep .v-input__slot {
  max-height: 100px !important;
}

.fixed-height-textarea ::v-deep textarea {
  line-height: 1.2;
  font-family: monospace;
  overflow-y: auto !important;
}

.public-key-container {
  position: relative;
  width: 100%;
}

.copy-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  z-index: 1;
}

.copy-btn:hover {
  background-color: #e0e0e0 !important;
}
</style>
